import styled, { css } from 'styled-components';
import { theme } from '../../../styles/theme';
import { mq } from '../../../styles/mq';

export const MenuItemContainer = styled.button`
  position: relative;
  width: 100%;
  border-radius: 3rem;
  height: 6rem;
  border: 1px solid ${theme.colors.text};
  background: ${theme.colors.background};
  margin: 1rem auto;
  cursor: pointer;
  font-family: 'Skolar Sans PE condensed';
  overflow: hidden;

  &::after {
    position: relative;
    content: counter(menu);
    counter-increment: menu;
    color: ${theme.colors.orange};
    font-size: 3rem;
    font-weight: 800;
    position: absolute;
    top: 0;
    left: 0;
    width: 5rem;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ${mq.xlarge} {
    border-radius: 4rem;
    height: 8rem;
    &::after {
      font-size: 4.2rem;
      width: 7rem;
      height: 8rem;
    }
  }
`;

export const ImageWrapper = styled.span`
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: 0.3s transform 0.3s linear;

  ${MenuItemContainer}:hover & {
    transform: translateY(100%);
    transition-duration: 10s;
    transition-delay: 0s;
  }
`;

export const BackgroundImage = styled.img<{
  $backgroundAnimation?: [number, number];
}>`
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  opacity: 0;
  transform: translateY(-10%);
  transition: opacity 0.3s, 0.3s transform 0.3s linear;

  ${MenuItemContainer}:hover & {
    opacity: 0.5;
    transform: translateY(-50%);
    transition-duration: 0.3s, 10s;
    transition-delay: 0s;
  }

  ${(props) =>
    !!props.$backgroundAnimation &&
    css`
      transform: translateY(-${props.$backgroundAnimation[0]}%);

      ${MenuItemContainer}:hover & {
        transform: translateY(-${props.$backgroundAnimation[1]}%);
      }
    `}
`;

export const MenuNumber = styled.div``;

export const MenuTitle = styled.div`
  position: relative;
  font-size: 2.1rem;
  font-weight: 800;
  color: ${theme.colors.text};
  padding: 0 3rem 0 5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  ${mq.xlarge} {
    font-size: 2.8rem;
    padding: 0 4rem 0 7rem;
  }
`;

export const MenuSubtitle = styled.div`
  position: relative;
  font-size: 1.5rem;
  color: ${theme.colors.text};
  padding-left: 5rem;
  ${mq.xlarge} {
    padding-left: 7rem;
    font-size: 1.8rem;
  }
  text-align: left;
  opacity: 0.6;
  transition: opacity 0.3s;
  ${MenuItemContainer}:hover & {
    opacity: 1;
  }
`;

export const MenuArrow = styled.div`
  position: absolute;
  right: 2.5rem;
  top: calc(50% - 4px);
  border-bottom: 2px solid ${theme.colors.text};
  border-right: 2px solid ${theme.colors.text};
  transform: rotate(45deg);
  width: 9px;
  height: 9px;
  ${mq.xlarge} {
    top: calc(50% - 6px);
    right: 3rem;
    width: 14px;
    height: 14px;
  }
  opacity: 0.3;
  transition: opacity 0.3s;
  ${MenuItemContainer}:hover & {
    opacity: 1;
  }
`;
